module.exports = __webpack_public_path__ + "static/media/primeship3.219d1726.png";